import { render, staticRenderFns } from "./jiaoyu-list.vue?vue&type=template&id=494acc4a&scoped=true&"
import script from "./jiaoyu-list.vue?vue&type=script&lang=js&"
export * from "./jiaoyu-list.vue?vue&type=script&lang=js&"
import style0 from "./jiaoyu-list.vue?vue&type=style&index=0&id=494acc4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494acc4a",
  null
  
)

export default component.exports